import { useLingui } from '@lingui/react/macro';
import { Stack, Typography, Tooltip, Box, Link } from '@mui/material';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { styled } from '@mui/material/styles';
import { useHeartbeatStore, computeConnectionStatusSummary, ConnectionHealth } from '@/common/heartbeatStore.ts';
import { environment } from '../../environment.ts';

const StatusDot = styled(Box)<{ health: ConnectionHealth }>(({ theme, health }) => {
  const colorMap: Record<ConnectionHealth, string> = {
    healthy: theme.palette.success.main,
    warning: theme.palette.warning.main,
    error: theme.palette.error.main,
    disconnected: theme.palette.grey[500],
  };

  return {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: colorMap[health],
  };
});

export function ConnectionStatus() {
  const { i18n } = useLingui();
  const { overallHealth, statusText, tooltipText } = useHeartbeatStore((state) => state.connectionStatusSummary);

  return (
    <Tooltip
      title={
        <div>
          {tooltipText.map((line, index) => (
            <div key={index}>{i18n._(line)}</div>
          ))}
        </div>
      }
      arrow
    >
      <Stack direction="row" alignItems="center" spacing={1} flexShrink={0}>
        <StatusDot health={overallHealth} />
        <Typography
          variant="body2"
          noWrap
          color={
            overallHealth === 'error'
              ? 'error.main'
              : overallHealth === 'warning'
                ? 'warning.main'
                : overallHealth === 'disconnected'
                  ? 'text.disabled'
                  : 'success.main'
          }
        >
          {i18n._(statusText)}
        </Typography>
        <Link href={environment.statusPageUrl} target="_blank" rel="noopener noreferrer" display="flex">
          <OpenInNewIcon fontSize="small" sx={{ color: 'text.secondary', fontSize: 14 }} />
        </Link>
      </Stack>
    </Tooltip>
  );
}
